import Vue from 'vue';
// import store from "../store";


let state = false;

function getState() {
  return state;
}

function toggle(flag) {
  if(typeof flag !== 'boolean'){
    state = !state;
  }else{
    state = flag;
  }
  if(state){
    Vue.prototype.$message.success('进入专业模式');
  }else{
    Vue.prototype.$message.warning('回到一般模式');
  }
  // professionalModeService.toggle();
  Vue.prototype.$store.dispatch('setIsProfessionalMode',getState())
}

export default {
  getState,
  toggle
}
